import { Grid } from '@material-ui/core';
import { RestartIcon } from 'app/assets/images/icons';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';
import ToolTipComp from '../ToolTipComp';
interface Props {
  time?: any;
}
const LastRegrabOn: FunctionComponent<Props> = ({ time }) => {
  return (
    <div data-testid="last-regrab-on">
      {time?.length > 0 ? (
        <ToolTipComp
          title={`${_t('basic:last_grabbed_on')} : ${dateTimeFormatter?.date(
            time
          )} ${_t('basic:at')} ${dateTimeFormatter?.time(time)}`}
        >
          <Grid item>
            <div>
              <RestartIcon />
            </div>
          </Grid>
        </ToolTipComp>
      ) : (
        <RestartIcon />
      )}
    </div>
  );
};

export default LastRegrabOn;
